<template>
  <div>
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>
    <v-dialog
      v-model="dialogDocumentReference"
      persistent
      max-width="75%"
    >
      <v-card
      >
        <v-card-title>
          Documentos de Referencia - [{{diagnosticoMedico.codigo}}] - {{diagnosticoMedico.diagnostico}}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="url"
                :items="diagnosticoMedico.documentos_referencias_bibliograficas"
                outlined
                dense
                hide-details
                label="Documento de Referencia Médica"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12"
              v-if="url != null"
              
            >
              {{url}}

              <PDFViewer
                :controls="controls"
                :source="`/api/ConsultasMedicas/DocumentoReferencia/${url}?jwt=${this.token}#toolbar=0&navpanes=0&scrollbar=0`"
                style="height: 100vh; width: 100%"
              />

            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            text
            @click="cerrarDocumentosReferencia"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="6">
        <span class="font-weight-bold">Antecedentes Heredo Familiares</span>
        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Diabetes: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_diabetes" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_diabetes_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Hipertensión: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_hipertension" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_hipertension_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Cardiopatias: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_cardiopatias" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_cardiopatias_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Respiratorias: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_respiratorias" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_respiratorias_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Reumáticas: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_reumaticas" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_reumaticas_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Neurológicas: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_neurologicas" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_neurologicas_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Endocrinas: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_endocrinas" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_endocrinas_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Cáncer: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_cancer" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_cancer_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Alérgicos: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_alergicos" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_alergicos_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Otros: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_hf_otros" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_hf_otros_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <span class="font-weight-bold">Personales Patológicos</span>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Diabetes: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_diabetes" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_diabetes_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Hipertensión: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_hipertension" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_hipertension_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Cáncer: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_cancer" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_cancer_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Cardiopatia: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_cardiopatia" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_cardiopatia_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Alérgicos: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_alergicos" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_alergicos_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Epilepsia: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_epilepsia" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_epilepsia_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Reumaticos: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_reumaticos" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_reumaticos_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Infecciosos: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_infecciosos" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_infecciosos_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Traumáticos: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_traumaticos" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_traumaticos_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Transfunciones: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_transfunciones" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_transfunciones_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Quirúrgicos: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_quirurgicos" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_quirurgicos_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Marcapasos: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pp_marcapasos" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pp_marcapasos_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <span class="font-weight-bold">Antecedentes personales no patológicos</span>
        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Alcoholismo: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pnp_alcoholismo" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pnp_alcoholismo_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Tabaquismo: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pnp_tabaquismo" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pnp_tabaquismo_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Toxicomanias: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pnp_toxicomanias" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pnp_toxicomanias_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Escolaridad: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pnp_escolaridad" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pnp_escolaridad_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <span class="font-weight-bold">&nbsp;</span>
        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Habitación: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pnp_habitacion" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Bueno" :value="1"></v-radio>
              <v-radio label="Regular" :value="2"></v-radio>
              <v-radio label="Malo" :value="3"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pnp_habitacion_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Alimentación: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pnp_alimentacion" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Bueno" :value="1"></v-radio>
              <v-radio label="Regular" :value="2"></v-radio>
              <v-radio label="Malo" :value="3"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pnp_alimentacion_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>

        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Hábitos Hig. </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pnp_habitos_hig" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Bueno" :value="1"></v-radio>
              <v-radio label="Regular" :value="2"></v-radio>
              <v-radio label="Malo" :value="3"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-textarea v-model="editedItem.ant_pnp_habitos_hig_otros" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <span>Otros:</span>
        <v-row class="pa-1 ma-0">
          <v-col cols="3" class="pa-0 ma-0"> Implantes: </v-col>
          <v-col cols="3" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.ant_pnp_implantes" required row hide-details dense class="ma-0 pa-0" @change="resetImplantes">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="pa-0 ma-0">
            <div class="d-flex align-center" v-if="editedItem.ant_pnp_implantes">
              <v-checkbox v-model="editedItem.ant_pnp_implantes_derecha" label="Derecha" class="ma-0 pa-0 mr-2" hide-details dense />
              <v-checkbox v-model="editedItem.ant_pnp_implantes_izquierda" label="Izquierda" class="ma-0 pa-0" hide-details dense />
            </div>
          </v-col>

          <v-col cols="12" class="ma-0 pa-0 pt-2" v-if="editedItem.ant_pnp_implantes">
            <v-datetime-picker
              label="Fecha"
              v-model="editedItem.ant_pnp_implantes_fecha"
            >
            </v-datetime-picker>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <span class="font-weight-bold">Antecedentes de Familiares Con Cáncer de Mama</span>
        <v-row class="ma-0 pa-0">
          <v-col cols="4" class="ma-0 pa-0">
            <v-checkbox v-model="editedItem.ant_familiares_cancer" label="Mamá" :value="1" dense hide-details></v-checkbox>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <v-checkbox v-model="editedItem.ant_familiares_cancer" label="Hija(s)" :value="4" dense hide-details></v-checkbox>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <v-checkbox v-model="editedItem.ant_familiares_cancer" label="Hermanas" :value="3" dense hide-details></v-checkbox>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <v-checkbox v-model="editedItem.ant_familiares_cancer" label="Abuela" :value="5" dense hide-details></v-checkbox>
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <v-checkbox v-model="editedItem.ant_familiares_cancer" label="Tías" :value="2" dense hide-details></v-checkbox>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <span class="font-weight-bold">Antecedentes Ginocobstétricos</span>
        <v-row class="ma-0 pa-0">
          <v-col cols="6" class="align-content-end pt-0">
            <v-text-field v-model="editedItem.ant_gin_menarca" label="Menarca (Inicio de la Primera Mestruación)" dense hide-details outlined>
            </v-text-field>
          </v-col>
          <v-col cols="3" class="align-content-end pt-0">
            <v-text-field v-model="editedItem.ant_gin_ritmo" label="Ritmo" dense hide-details outlined>
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pt-0">
            Gestas:
            <VueNumberInput
              v-model="editedItem.ant_gin_gestas"
              :min="0"
              center
              readonly
              size="small"
            ></VueNumberInput>
          </v-col>

          <v-col cols="3">
            Paras:
            <VueNumberInput
              v-model="editedItem.ant_gin_paras"
              :min="0"
              :max="10"
              controls
              center
              size="small"
              @change="calcularGestas"
            ></VueNumberInput>
          </v-col>
          <v-col cols="3">
            Cesáreas:
            <VueNumberInput
              v-model="editedItem.ant_gin_cesarias"
              :min="0"
              :max="10"
              controls
              center
              size="small"
              @change="calcularGestas"
            ></VueNumberInput>
          </v-col>
          <v-col cols="3">
            Abortos:
            <VueNumberInput
              v-model="editedItem.ant_gin_abortos"
              :min="0"
              :max="10"
              controls
              center
              size="small"
              @change="calcularGestas"
            ></VueNumberInput>
          </v-col>
          <v-col cols="3" class="align-content-end">
            <v-datetime-picker
              label="Fecha de Última Menstruación"
              v-model="editedItem.ant_gin_fum"
            >
            </v-datetime-picker>
          </v-col>

          <v-col cols="12">
            <v-text-field v-model="editedItem.ant_gin_metodos_planificacion" label="Métodos de Planificación Familiar" dense hide-details outlined>
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field v-model="editedItem.ant_gin_tratamiento_hormonal" label="Uso de Tratamiento Hormonal" dense hide-details outlined>
            </v-text-field>
          </v-col>

          <v-col cols="3" class="align-self-center"> ¿Se ha realizado una mastografia anteriormente? </v-col>
          <v-col cols="2" class="align-self-center">
            <v-radio-group v-model="editedItem.ant_gin_mastografia" required row hide-details dense class="ma-0 pa-0" @change="resetMastografia">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="7" class="align-self-center">
            <v-row class="ma-0 pa-0" v-if="editedItem.ant_gin_mastografia">
              <v-row class="ma-0 pa-0">
                <v-col cols="4" >
                  <v-datetime-picker
                    label="Fecha"
                    v-model="editedItem.ant_gin_mastografia_fecha"
                  >
                  </v-datetime-picker>
                </v-col>
                <v-col cols="4" class="align-self-center">
                  <v-autocomplete
                    v-model="editedItem.ant_gin_mastografia_resultado"
                    label="Resultado de última mastografía"
                    dense
                    hide-details
                    outlined
                    :items="escalaCancerMama"
                    item-value="id_escala_cancer_mama"
                    :item-text="nombreEscala"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="4" class="align-self-center">
                  <div class="d-flex flex-column">
                    <label class="mb-1">Tratamiento</label>
                    <v-radio-group v-model="editedItem.ant_gin_mastografia_tratamiento" row hide-details dense class="ma-0 pa-0">
                      <v-radio label="Sí" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                  </div>
                </v-col>
              </v-row>
            </v-row>
          </v-col>

          <v-col cols="3" class="align-self-center"> Paciente Referido: </v-col>
          <v-col cols="9" class="align-self-center">
            <v-radio-group v-model="editedItem.paciente_referenciado" required row hide-details dense class="ma-0 pa-0" @change="editedItem.procedencia = null">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12" v-if="editedItem.paciente_referenciado">
            <v-textarea label="Procedencia" v-model="editedItem.procedencia" :rows="1" auto-grow outlined hide-details dense>
            </v-textarea>
          </v-col>



          <v-col cols="3" class="align-self-center"> Padecimiento de Cáncer de Mama: </v-col>
          <v-col cols="2" class="align-self-center">
            <v-radio-group v-model="editedItem.ant_gin_padecimiento_cancer" required row hide-details dense class="ma-0 pa-0" @change="editedItem.ant_gin_padecimiento_cancer_otros = null">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="7">
            <template v-if="editedItem.ant_gin_padecimiento_cancer">
              <v-textarea v-model="editedItem.ant_gin_padecimiento_cancer_otros" :rows="1" auto-grow outlined hide-details dense>
              </v-textarea>
            </template>
          </v-col>

          <v-col cols="3" class="align-self-center"> ¿Le han realizado la mastectomía? </v-col>
          <v-col cols="2" class="align-self-center">
            <v-radio-group v-model="editedItem.ant_gin_mastectomia" required row hide-details dense class="ma-0 pa-0" @change="resetRealizarMastografia">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="7" class="align-self-center">
            <v-row class="ma-0 pa-0" v-if="editedItem.ant_gin_mastectomia">
              <v-col cols="6" class="pa-0 ma-0 align-self-center">
                <div class="d-flex align-center">
                  <v-checkbox v-model="editedItem.ant_gin_mastectomia_derecha" class="ma-0 pa-0 mr-4" label="Derecha" hide-details dense />
                  <v-checkbox v-model="editedItem.ant_gin_mastectomia_izquierda" class="ma-0 pa-0" label="Izquierda" hide-details dense />
                </div>
              </v-col>
              <v-col cols="6" class="ma-0 pa-0">
                <v-datetime-picker
                  label="Fecha"
                  v-model="editedItem.ant_gin_mastectomia_fecha"
                >
                </v-datetime-picker>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="3"> ¿Tiene sospecha de estar embarazada? </v-col>
          <v-col cols="2">
            <v-radio-group v-model="editedItem.ant_gin_mastectomia_sospecha_embarazo" required row hide-details dense class="ma-0 pa-0" @change="editedItem.ant_gin_mastectomia_sospecha_embarazo_otros = null">
              <v-radio label="Si" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="7">
            <template v-if="editedItem.ant_gin_mastectomia_sospecha_embarazo">
              <v-textarea v-model="editedItem.ant_gin_mastectomia_sospecha_embarazo_otros" :rows="1" auto-grow outlined hide-details dense>
              </v-textarea>
            </template>
          </v-col>

        </v-row>
      </v-col>

       <v-col cols="12">
        <span class="font-weight-bold">Exploración Clínica</span>
       </v-col>
       <v-col cols="12">
        <div class="font-weight-bold">Signos clínicos</div>
        <v-row dense>
          <v-col cols="6">
            <v-checkbox
              v-model="editedItem.signos_clinicos"
              label="1. Nódulos sólidos, irregulares de consistencia dura o planos profundos"
              :value="1"
              dense
              hide-details
            />
            <v-checkbox
              v-model="editedItem.signos_clinicos"
              label="2. Cambios cutáneos evidentes (piel de naranja, retracción de la piel, lesión areolar que no cicatriza a pesar del tratamiento)"
              :value="2"
              dense
              hide-details
            />
            <v-checkbox
              v-model="editedItem.signos_clinicos"
              label="3. Zona de sistematización en el tejido glandular focalizado a una sola mama y región"
              :value="3"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="editedItem.signos_clinicos"
              label="4. Secreción serosanguinolenta"
              :value="4"
              dense
              hide-details
            />
            <v-checkbox
              v-model="editedItem.signos_clinicos"
              label="5. Crecimiento ganglionar axilar o supraclavicular"
              :value="5"
              dense
              hide-details
            />
            <v-checkbox
              v-model="editedItem.signos_clinicos"
              label="6. Retracción o jación del pezón"
              :value="6"
              dense
              hide-details
            />
            <v-checkbox
              v-model="editedItem.signos_clinicos"
              label="7. Ninguno"
              :value="7"
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" class="ma-0 pa-0 pt-2">
        <v-datetime-picker
          label="Fecha de Inicio del Primer Síntoma o Signo"
          v-model="editedItem.fecha_primer_sintoma"
        >
        </v-datetime-picker>
      </v-col>

      <v-col cols="12" v-if="mostrar">
        <diagrama
          v-model="editedItem.localizaciones"
          ref="diagrama"
        >
        </diagrama>
       </v-col>

      <v-col cols="12" class="py-0 my-0">
        <span class="font-weight-bold">Padecimiento Actual Principales Sintomas</span>
        <v-textarea v-model="editedItem.padecimiento_actual" :rows="1" auto-grow outlined hide-details dense> </v-textarea>
      </v-col>

      <v-col cols="12" class="py-0 my-0">
        <v-row class="ma-0 pa-0">
          <v-col cols="6">
            <span class="font-weight-bold">Exploración Física</span>
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="pl-0 ml-0 pt-0 m-0">
                <v-text-field v-model="editedItem.ta" label="TA" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.talla" label="Talla" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.pulso" label="Pulso" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.fr" label="FR" dense hide-details outlined class="py-2">
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pr-0 mr-0 pt-0 m-0">
                <v-text-field v-model="editedItem.peso" label="Peso" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.circunferencia_abdominal" label="Circunferencia Abdominal" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field  v-model="editedItem.temp" label="Temp" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field  v-model="editedItem.imc" label="IMC" dense hide-details outlined class="py-2">
                </v-text-field>
              </v-col>
            </v-row>
            <br />
            <span class="font-weight-bold">Laboratorio</span>
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="pl-0 ml-0 pt-0 m-0">
                <v-text-field v-model="editedItem.gpo" label="GPO" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.rh" label="Rh" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.glucosa" label="Glucosa" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.colesterol" label="Colesterol" dense hide-details outlined class="py-2">
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pr-0 mr-0 pt-0 m-0">
                <v-text-field v-model="editedItem.trigliceridos" label="TRIG" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.acido_urico" label="AC. Úrico" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.vdrl" label="VDRL" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.otros" label="Otros" dense hide-details outlined class="py-2">
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <span class="font-weight-bold">&nbsp;</span>
            <v-row class="ma-0 pa-0">
              <v-col cols="3" class="pa-0 ma-0 py-1"> Cabeza </v-col>
              <v-col cols="4" class="pa-0 ma-0 py-1">
                <v-radio-group v-model="editedItem.exp_fis_cabeza" required row hide-details dense class="ma-0 pa-0">
                  <v-radio label="Normal" :value="true"></v-radio>
                  <v-radio label="Anormal" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="5" class="ma-0 pa-0 py-1">
                <v-textarea v-model="editedItem.exp_fis_cabeza_otros" :rows="1" auto-grow outlined hide-details dense>
                </v-textarea>
              </v-col>

              <v-col cols="3" class="pa-0 ma-0 py-1"> Cuello </v-col>
              <v-col cols="4" class="pa-0 ma-0 py-1">
                <v-radio-group v-model="editedItem.exp_fis_cuello" required row hide-details dense class="ma-0 pa-0">
                  <v-radio label="Normal" :value="true"></v-radio>
                  <v-radio label="Anormal" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="5" class="ma-0 pa-0 py-1">
                <v-textarea v-model="editedItem.exp_fis_cuello_otros" :rows="1" auto-grow outlined hide-details dense>
                </v-textarea>
              </v-col>

              <v-col cols="3" class="pa-0 ma-0 py-1"> Tórax </v-col>
              <v-col cols="4" class="pa-0 ma-0 py-1">
                <v-radio-group v-model="editedItem.exp_fis_torax" required row hide-details dense class="ma-0 pa-0">
                  <v-radio label="Normal" :value="true"></v-radio>
                  <v-radio label="Anormal" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="5" class="ma-0 pa-0 py-1">
                <v-textarea v-model="editedItem.exp_fis_torax_otros" :rows="1" auto-grow outlined hide-details dense>
                </v-textarea>
              </v-col>

              <v-col cols="3" class="pa-0 ma-0 py-1"> Abdomen </v-col>
              <v-col cols="4" class="pa-0 ma-0 py-1">
                <v-radio-group v-model="editedItem.exp_fis_abdomen" required row hide-details dense class="ma-0 pa-0">
                  <v-radio label="Normal" :value="true"></v-radio>
                  <v-radio label="Anormal" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="5" class="ma-0 pa-0 py-1">
                <v-textarea v-model="editedItem.exp_fis_abdomen_otros" :rows="1" auto-grow outlined hide-details dense>
                </v-textarea>
              </v-col>

              <v-col cols="3" class="pa-0 ma-0 py-1"> Columna Lumbar </v-col>
              <v-col cols="4" class="pa-0 ma-0 py-1">
                <v-radio-group v-model="editedItem.exp_fis_columba_lumbar" required row hide-details dense class="ma-0 pa-0">
                  <v-radio label="Normal" :value="true"></v-radio>
                  <v-radio label="Anormal" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="5" class="ma-0 pa-0 py-1">
                <v-textarea v-model="editedItem.exp_fis_columba_lumbar_otros" :rows="1" auto-grow outlined hide-details dense>
                </v-textarea>
              </v-col>

              <v-col cols="3" class="pa-0 ma-0 py-1"> Extermidades Sup </v-col>
              <v-col cols="4" class="pa-0 ma-0 py-1">
                <v-radio-group v-model="editedItem.exp_fis_ext_sup" required row hide-details dense class="ma-0 pa-0">
                  <v-radio label="Normal" :value="true"></v-radio>
                  <v-radio label="Anormal" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="5" class="ma-0 pa-0 py-1">
                <v-textarea v-model="editedItem.exp_fis_ext_sup_otros" :rows="1" auto-grow outlined hide-details dense>
                </v-textarea>
              </v-col>

              <v-col cols="3" class="pa-0 ma-0 py-1"> Extermidades Inf </v-col>
              <v-col cols="4" class="pa-0 ma-0 py-1">
                <v-radio-group v-model="editedItem.exp_fis_ext_inf" required row hide-details dense class="ma-0 pa-0">
                  <v-radio label="Normal" :value="true"></v-radio>
                  <v-radio label="Anormal" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="5" class="ma-0 pa-0 py-1">
                <v-textarea v-model="editedItem.exp_fis_ext_inf_otros" :rows="1" auto-grow outlined hide-details dense>
                </v-textarea>
              </v-col>
            </v-row>
            <br />
            <span class="font-weight-bold">Auxiliares de Diagnóstico</span>
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="pl-0 ml-0 pt-0 m-0">
                <v-text-field v-model="editedItem.aux_diag_us" label="US" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.aux_diag_ecg" label="ECG" dense hide-details outlined class="py-2">
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pr-0 mr-0 pt-0 m-0">
                <v-text-field v-model="editedItem.aux_diag_rx" label="RX" dense hide-details outlined class="py-2">
                </v-text-field>
                <v-text-field v-model="editedItem.aux_diag_otros" label="Otros" dense hide-details outlined class="py-2">
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-if="diagnosticosMedicosFocus"
          label="Diagnósticos"
          v-model="editedItem.ids_diagnosticos_medicos"
          outlined
          :items="diagnosticoMedicos"
          item-value="id_diagnostico_medico"
          item-text="diagnostico"
          multiple
          hide-details
          chips
          deletable-chips
        >
          <template v-slot:selection="{ item, attrs }">
            <v-chip
              v-bind="attrs"
              :input-value="editedItem.ids_diagnosticos_medicos.includes(item.id_diagnostico_medico)"
              close
              close-icon="mdi-close-circle"
              @click.native="abrirDocumentosReferencia(item)"
              @click:close="borrarChip(item)"
            >
              <v-icon
                v-if="item.ids_documentos_referencias_bibliograficas.length > 0"
              >
                mdi-file-document-outline
              </v-icon>
              {{ item.diagnostico }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" class="py-0 my-0">
        <span class="font-weight-bold">Tratamientos Indicados</span>
        <v-textarea v-model="editedItem.tratamientos_indicados" :rows="1" auto-grow outlined hide-details dense> </v-textarea>
      </v-col>
      
      <v-col cols="12" class="ma-0 pa-0">
        <br>
        <v-row class="pa-1 ma-0">
          <v-col cols="4" class="pa-0 ma-0 font-weight-bold">
            Incluir Medicamentos
          </v-col>
          <v-col cols="8" class="pa-0 ma-0">
            <v-radio-group
              v-model="editedItem.receta_medica"
              required
              row
              hide-details
              dense
              class="ma-0 pa-0"
            >
              <v-radio
                  label="Si"
                  :value="true"
              ></v-radio>
              <v-radio
                label="No"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row class="ma-0 pa-0"
          v-if="editedItem.receta_medica"
        >
          <v-col cols="12">
            <v-data-table
              :headers="headersMedicamentos"
              :items="editedItem.tratamientos"
              hide-default-footer
              hide-default-header
            >
              <template v-slot:[`item.tratamiento`]="{ item }">
                <v-row class="ma-0 pa-0">
                  <v-col cols="8" class="ma-0 pa-2">
                    <v-autocomplete
                      v-model="item.id_medicamento"
                      outlined
                      label="Medicamento"
                      hide-details
                      :items="medicamentos"
                      :item-text="medicamentoNombre"
                      item-value="id_medicamento"
                      dense
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" class="ma-0 pa-2">
                    <v-number-field
                      v-model="item.cantidad"
                      label="Cantidad"
                    >
                    </v-number-field>
                  </v-col>
                  <v-col cols="12" class="ma-0 pa-2">
                    <v-textarea
                      v-model="item.indicaciones"
                      outlined
                      label="Indicaciones"
                      rows="1"
                      auto-grow
                      dense
                      hide-details
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip-icon
                  icon="mdi-trash-can-outline"
                  text="Eliminar"
                  @click="eliminarMedicamento(item)"
                ></v-tooltip-icon>
              </template> 
            </v-data-table>
            <v-btn
              color="primary"
              @click="agregarMedicamento"
              text
            >
              Agregar Medicamento
            </v-btn>
          </v-col>
        </v-row>
        <br>
      </v-col>

      <v-col cols="12">
        <v-row class="ma-0 pa-0">
          <v-col cols="1" class="pa-0 ma-0 font-weight-bold"> Pronóstico </v-col>
          <v-col cols="11" class="pa-0 ma-0">
            <v-radio-group v-model="editedItem.pronostico" required row hide-details dense class="ma-0 pa-0">
              <v-radio label="Bueno" :value="true"></v-radio>
              <v-radio label="Reservado" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <br>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from "axios"
import VAlertDialog from '@/components/VAlertDialog.vue'
import VueNumberInput from "@chenfengyuan/vue-number-input";
import VDatetimePicker from '@/components/VDatetimePickerClear.vue';
import Diagrama from './Diagrama.vue'
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'

export default {
  components: {
    VAlertDialog,
    VueNumberInput,
    VDatetimePicker,
    Diagrama,
    PDFViewer
  },
  computed: {
    ...mapState(['token']),
  },
  data: () => ({
    editedItem: {
      ant_hf_diabetes: null,
      ant_hf_diabetes_otros: null,
      ant_hf_hipertension: null,
      ant_hf_hipertension_otros: null,
      ant_hf_cardiopatias: null,
      ant_hf_cardiopatias_otros: null,
      ant_hf_respiratorias: null,
      ant_hf_respiratorias_otros: null,
      ant_hf_reumaticas: null,
      ant_hf_reumaticas_otros: null,
      ant_hf_neurologicas: null,
      ant_hf_neurologicas_otros: null,
      ant_hf_endocrinas: null,
      ant_hf_endocrinas_otros: null,
      ant_hf_cancer: null,
      ant_hf_cancer_otros: null,
      ant_hf_alergicos: null,
      ant_hf_alergicos_otros: null,
      ant_hf_otros: null,
      ant_hf_otros_otros: null,
      ant_pp_diabetes: null,
      ant_pp_diabetes_otros: null,
      ant_pp_hipertension: null,
      ant_pp_hipertension_otros: null,
      ant_pp_cancer: null,
      ant_pp_cancer_otros: null,
      ant_pp_cardiopatia: null,
      ant_pp_cardiopatia_otros: null,
      ant_pp_alergicos: null,
      ant_pp_alergicos_otros: null,
      ant_pp_epilepsia: null,
      ant_pp_epilepsia_otros: null,
      ant_pp_reumaticos: null,
      ant_pp_reumaticos_otros: null,
      ant_pp_infecciosos: null,
      ant_pp_infecciosos_otros: null,
      ant_pp_traumaticos: null,
      ant_pp_traumaticos_otros: null,
      ant_pp_transfunciones: null,
      ant_pp_transfunciones_otros: null,
      ant_pp_quirurgicos: null,
      ant_pp_quirurgicos_otros: null,
      ant_pp_marcapasos: null,
      ant_pp_marcapasos_otros: null,
      ant_pnp_alcoholismo: null,
      ant_pnp_alcoholismo_otros: null,
      ant_pnp_tabaquismo: null,
      ant_pnp_tabaquismo_otros: null,
      ant_pnp_toxicomanias: null,
      ant_pnp_toxicomanias_otros: null,
      ant_pnp_escolaridad: null,
      ant_pnp_escolaridad_otros: null,
      ant_pnp_habitacion: null,
      ant_pnp_habitacion_otros: null,
      ant_pnp_alimentacion: null,
      ant_pnp_alimentacion_otros: null,
      ant_pnp_habitos_hig: null,
      ant_pnp_habitos_hig_otros: null,
      ant_pnp_implantes: null,
      ant_pnp_implantes_derecha: null,
      ant_pnp_implantes_izquierda: null,
      ant_pnp_implantes_fecha: null,
      ant_familiares_cancer: [],
      ant_gin_menarca: null,
      ant_gin_ritmo: null,
      ant_gin_gestas: 0,
      ant_gin_paras: 0,
      ant_gin_cesarias: 0,
      ant_gin_abortos: 0,
      ant_gin_fum: null,
      ant_gin_metodos_planificacion: null,
      ant_gin_tratamiento_hormonal: null,
      ant_gin_padecimiento_cancer: null,
      ant_gin_padecimiento_cancer_otros: null,
      ant_gin_mastectomia: null,
      ant_gin_mastectomia_derecha: null,
      ant_gin_mastectomia_izquierda: null,
      ant_gin_mastectomia_fecha: null,
      ant_gin_mastectomia_sospecha_embarazo: null,
      ant_gin_mastectomia_sospecha_embarazo_otros: null,
      ant_gin_mastografia: null,
      ant_gin_mastografia_fecha: null,
      ant_gin_mastografia_resultado : null,
      ant_gin_mastografia_tratamiento: null,
      paciente_referenciado: null,
      procedencia: null,
      padecimiento_actual: null,
      ta: null,
      talla: null,
      pulso: null,
      fr: null,
      peso: null,
      circunferencia_abdominal: null,
      temp: null,
      imc: null,
      gpo: null,
      rh: null,
      glucosa: null,
      colesterol: null,
      trigliceridos: null,
      acido_urico: null,
      vdrl: null,
      otros: null,
      exp_fis_cabeza: null,
      exp_fis_cabeza_otros: null,
      exp_fis_cuello: null,
      exp_fis_cuello_otros: null,
      exp_fis_torax: null,
      exp_fis_torax_otros: null,
      exp_fis_abdomen: null,
      exp_fis_abdomen_otros: null,
      exp_fis_columba_lumbar: null,
      exp_fis_columba_lumbar_otros: null,
      exp_fis_ext_sup: null,
      exp_fis_ext_sup_otros: null,
      exp_fis_ext_inf: null,
      exp_fis_ext_inf_otros: null,
      aux_diag_us: null,
      aux_diag_ecg: null,
      aux_diag_rx: null,
      aux_diag_otros: null,
      signos_clinicos: [],
      fecha_primer_sintoma: null,
      localizaciones: [],
      ids_diagnosticos_medicos: [],
      tratamientos_indicados: null,
      receta_medica: false,
      tratamientos: [],
      pronostico: null
    },
    defaultEditedItem: {
      ant_hf_diabetes: null,
      ant_hf_diabetes_otros: null,
      ant_hf_hipertension: null,
      ant_hf_hipertension_otros: null,
      ant_hf_cardiopatias: null,
      ant_hf_cardiopatias_otros: null,
      ant_hf_respiratorias: null,
      ant_hf_respiratorias_otros: null,
      ant_hf_reumaticas: null,
      ant_hf_reumaticas_otros: null,
      ant_hf_neurologicas: null,
      ant_hf_neurologicas_otros: null,
      ant_hf_endocrinas: null,
      ant_hf_endocrinas_otros: null,
      ant_hf_cancer: null,
      ant_hf_cancer_otros: null,
      ant_hf_alergicos: null,
      ant_hf_alergicos_otros: null,
      ant_hf_otros: null,
      ant_hf_otros_otros: null,
      ant_pp_diabetes: null,
      ant_pp_diabetes_otros: null,
      ant_pp_hipertension: null,
      ant_pp_hipertension_otros: null,
      ant_pp_cancer: null,
      ant_pp_cancer_otros: null,
      ant_pp_cardiopatia: null,
      ant_pp_cardiopatia_otros: null,
      ant_pp_alergicos: null,
      ant_pp_alergicos_otros: null,
      ant_pp_epilepsia: null,
      ant_pp_epilepsia_otros: null,
      ant_pp_reumaticos: null,
      ant_pp_reumaticos_otros: null,
      ant_pp_infecciosos: null,
      ant_pp_infecciosos_otros: null,
      ant_pp_traumaticos: null,
      ant_pp_traumaticos_otros: null,
      ant_pp_transfunciones: null,
      ant_pp_transfunciones_otros: null,
      ant_pp_quirurgicos: null,
      ant_pp_quirurgicos_otros: null,
      ant_pp_marcapasos: null,
      ant_pp_marcapasos_otros: null,
      ant_pnp_alcoholismo: null,
      ant_pnp_alcoholismo_otros: null,
      ant_pnp_tabaquismo: null,
      ant_pnp_tabaquismo_otros: null,
      ant_pnp_toxicomanias: null,
      ant_pnp_toxicomanias_otros: null,
      ant_pnp_escolaridad: null,
      ant_pnp_escolaridad_otros: null,
      ant_pnp_habitacion: null,
      ant_pnp_habitacion_otros: null,
      ant_pnp_alimentacion: null,
      ant_pnp_alimentacion_otros: null,
      ant_pnp_habitos_hig: null,
      ant_pnp_habitos_hig_otros: null,
      ant_pnp_implantes: null,
      ant_pnp_implantes_derecha: null,
      ant_pnp_implantes_izquierda: null,
      ant_pnp_implantes_fecha: null,
      ant_familiares_cancer: [],
      ant_gin_menarca: null,
      ant_gin_ritmo: null,
      ant_gin_gestas: 0,
      ant_gin_paras: 0,
      ant_gin_cesarias: 0,
      ant_gin_abortos: 0,
      ant_gin_fum: null,
      ant_gin_metodos_planificacion: null,
      ant_gin_tratamiento_hormonal: null,
      ant_gin_padecimiento_cancer: null,
      ant_gin_padecimiento_cancer_otros: null,
      ant_gin_mastectomia: null,
      ant_gin_mastectomia_derecha: null,
      ant_gin_mastectomia_izquierda: null,
      ant_gin_mastectomia_fecha: null,
      ant_gin_mastectomia_sospecha_embarazo: null,
      ant_gin_mastectomia_sospecha_embarazo_otros: null,
      ant_gin_mastografia: null,
      ant_gin_mastografia_fecha: null,
      ant_gin_mastografia_resultado : null,
      ant_gin_mastografia_tratamiento: null,
      paciente_referenciado: null,
      procedencia: null,
      padecimiento_actual: null,
      ta: null,
      talla: null,
      pulso: null,
      fr: null,
      peso: null,
      circunferencia_abdominal: null,
      temp: null,
      imc: null,
      gpo: null,
      rh: null,
      glucosa: null,
      colesterol: null,
      trigliceridos: null,
      acido_urico: null,
      vdrl: null,
      otros: null,
      exp_fis_cabeza: null,
      exp_fis_cabeza_otros: null,
      exp_fis_cuello: null,
      exp_fis_cuello_otros: null,
      exp_fis_torax: null,
      exp_fis_torax_otros: null,
      exp_fis_abdomen: null,
      exp_fis_abdomen_otros: null,
      exp_fis_columba_lumbar: null,
      exp_fis_columba_lumbar_otros: null,
      exp_fis_ext_sup: null,
      exp_fis_ext_sup_otros: null,
      exp_fis_ext_inf: null,
      exp_fis_ext_inf_otros: null,
      aux_diag_us: null,
      aux_diag_ecg: null,
      aux_diag_rx: null,
      aux_diag_otros: null,
      signos_clinicos: [],
      fecha_primer_sintoma: null,
      localizaciones: [],
      ids_diagnosticos_medicos: [],
      tratamientos_indicados: null,
      receta_medica: false,
      tratamientos: [],
      pronostico: null
    },
    validations:[
      { nombre: 'Antecedentes Heredo Familiares - Diabetes', campo: 'ant_hf_diabetes', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Hipertensión', campo: 'ant_hf_hipertension', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Cardiopatias', campo: 'ant_hf_cardiopatias', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Respiratorias', campo: 'ant_hf_respiratorias', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Reumáticas', campo: 'ant_hf_reumaticas', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Neurológicas', campo: 'ant_hf_neurologicas', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Endocrinas', campo: 'ant_hf_endocrinas', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Cáncer', campo: 'ant_hf_cancer', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Alérgicos', campo: 'ant_hf_alergicos', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Heredo Familiares - Otros', campo: 'ant_hf_otros', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Diabetes', campo: 'ant_pp_diabetes', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Hipertensión', campo: 'ant_pp_hipertension', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Cáncer', campo: 'ant_pp_cancer', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Cardiopatía', campo: 'ant_pp_cardiopatia', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Alérgicos', campo: 'ant_pp_alergicos', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Epilepsia', campo: 'ant_pp_epilepsia', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Reumaticos', campo: 'ant_pp_reumaticos', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Infecciosos', campo: 'ant_pp_infecciosos', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Traumáticos', campo: 'ant_pp_traumaticos', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Transfuncionales', campo: 'ant_pp_transfunciones', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Quirúrgicos', campo: 'ant_pp_quirurgicos', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Personales Patológicos - Marcapasos', campo: 'ant_pp_marcapasos', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Personales No Patológicos - Alcoholismo', campo: 'ant_pnp_alcoholismo', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Personales No Patológicos - Tabaquismo', campo: 'ant_pnp_tabaquismo', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Personales No Patológicos - Toxicomanias', campo: 'ant_pnp_toxicomanias', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Personales No Patológicos - Escolaridad', campo: 'ant_pnp_escolaridad', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Personales No Patológicos - Habitación', campo: 'ant_pnp_habitacion', tipo: 'integer', otro: true, valor_otro: 3 },
      { nombre: 'Antecedentes Personales No Patológicos - Alimentación', campo: 'ant_pnp_alimentacion', tipo: 'integer', otro: true, valor_otro: 3 },
      { nombre: 'Antecedentes Personales No Patológicos - Hábitos Hig.', campo: 'ant_pnp_habitos_hig', tipo: 'integer', otro: true, valor_otro: 3 },
      { nombre: 'Antecedentes Personales No Patológicos - Implantes', campo: 'ant_pnp_implantes', tipo: 'boolean', otro: false },
      { nombre: 'Antecedentes Personales No Patológicos - Implantes - Derecha & Izquierda', campo: 'ant_pnp_implantes_derecha_izquierda', especial: 1 },
      { nombre: 'Antecedentes Personales No Patológicos - Implantes - Fecha', campo: 'ant_pnp_implantes_fecha', especial: 2 },
      { nombre: 'Antecedentes Ginecobstétrico - Menarca', campo: 'ant_gin_menarca', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Ritmo', campo: 'ant_gin_ritmo', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Gestas', campo: 'ant_gin_gestas', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Paras', campo: 'ant_gin_paras', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Cesáreas', campo: 'ant_gin_cesarias', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Abortos', campo: 'ant_gin_abortos', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Fecha de Última Menstruación', campo: 'ant_gin_fum', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Métodos de Planificación Familiar', campo: 'ant_gin_metodos_planificacion', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Uso de Tratamiento Hormonal', campo: 'ant_gin_tratamiento_hormonal', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - Pacedimiento de Cáncer de Mama', campo: 'ant_gin_padecimiento_cancer', tipo: 'boolean', otro: true, valor_otro: true },
      { nombre: 'Antecedentes Ginecobstétrico - ¿Le han realizado la mastectomia?', campo: 'ant_gin_mastectomia', tipo: 'boolean', otro: false },
      { nombre: 'Antecedentes Ginecobstétrico - Derecha & Izquierda', campo: 'ant_gin_mastectomia_derecha_izquierda', especial: 3 },
      { nombre: 'Antecedentes Ginecobstétrico - Fecha', campo: 'ant_gin_mastectomia_fecha', especial: 4 },
      { nombre: 'Antecedentes Ginecobstétrico - ¿Se ha realizado una mastografia anteriormente?', campo: 'ant_gin_mastografia', tipo: 'boolean', otro: false },
      { nombre: 'Antecedentes Ginecobstétrico - Fecha de la Ultima Mastografia', campo: 'ant_gin_mastectomia_fecha', especial: 5 },
      { nombre: 'Antecedentes Ginecobstétrico - Resultado de la Ultima Mastografia', campo: 'ant_gin_mastectomia_fecha', especial: 6 },
      { nombre: 'Padecimiento Actual Principales Sintomas', campo: 'padecimiento_actual', tipo: 'string' },
      { nombre: 'Antecedentes Ginecobstétrico - ¿Le han realizado la mastectomia?', campo: 'ant_gin_mastectomia', tipo: 'boolean', otro: false },
      //{ nombre: 'Exploración Física - TA', campo: 'ta', tipo: 'string' },
      { nombre: 'Exploración Física - Talla', campo: 'talla', tipo: 'string' },
      { nombre: 'Exploración Física - Pulso', campo: 'pulso', tipo: 'string' },
      { nombre: 'Exploración Física - FR', campo: 'fr', tipo: 'string' },
      { nombre: 'Exploración Física - Peso', campo: 'peso', tipo: 'string' },
      //{ nombre: 'Exploración Física - Circunferencia Abdominal', campo: 'circunferencia_abdominal', tipo: 'string' },
      { nombre: 'Exploración Física - Temp', campo: 'temp', tipo: 'string' },
      { nombre: 'Exploración Física - IMC', campo: 'imc', tipo: 'string' },
      /*
      { nombre: 'Laboratorio - GPO', campo: 'gpo', tipo: 'string' },
      { nombre: 'Laboratorio - Rh', campo: 'rh', tipo: 'string' },
      { nombre: 'Laboratorio - Glucosa', campo: 'glucosa', tipo: 'string' },
      { nombre: 'Laboratorio - Colesterol', campo: 'colesterol', tipo: 'string' },
      { nombre: 'Laboratorio - Trig', campo: 'trigliceridos', tipo: 'string' },
      { nombre: 'Laboratorio - AC. Úrico', campo: 'acido_urico', tipo: 'string' },
      { nombre: 'Laboratorio - VDRL', campo: 'vdrl', tipo: 'string' },
       */
      { nombre: 'Exploración Física - Cabeza', campo: 'exp_fis_cabeza', tipo: 'boolean', otro: true, valor_otro: false },
      { nombre: 'Exploración Física - Cuello', campo: 'exp_fis_cuello', tipo: 'boolean', otro: true, valor_otro: false },
      { nombre: 'Exploración Física - Tórax', campo: 'exp_fis_torax', tipo: 'boolean', otro: true, valor_otro: false },
      { nombre: 'Exploración Física - Abdomen', campo: 'exp_fis_abdomen', tipo: 'boolean', otro: true, valor_otro: false },
      { nombre: 'Exploración Física - Columna Lumbar', campo: 'exp_fis_columba_lumbar', tipo: 'boolean', otro: true, valor_otro: false },
      { nombre: 'Exploración Física - Extremidades Sup', campo: 'exp_fis_ext_sup', tipo: 'boolean', otro: true, valor_otro: false },
      { nombre: 'Exploración Física - Extremidades Inf', campo: 'exp_fis_ext_inf', tipo: 'boolean', otro: true, valor_otro: false },
      /*
      { nombre: 'Auxiliares de Diagnóstico - US', campo: 'aux_diag_us', tipo: 'string' },
      { nombre: 'Auxiliares de Diagnóstico - ECG', campo: 'aux_diag_ecg', tipo: 'string' },
      { nombre: 'Auxiliares de Diagnóstico - RX', campo: 'aux_diag_rx', tipo: 'string' },
       */
      { nombre: 'Diagnósticos', campo: 'ids_diagnosticos_medicos', especial: 7  },
      { nombre: 'Tratamientos Indicados', campo: 'tratamientos_indicados', tipo: 'string' },
      { nombre: 'Pronóstico', campo: 'pronostico', tipo: 'boolean', otro: false },
    ],
    loadingEscalaCancerMamas: false,
    escalaCancerMama: [],
    dialogDocumentReference: false,
    diagnosticoMedico: {
      cie10: "",
      codigo: "",
      diagnostico: "",
      documentos_referencias_bibliograficas: [],
      id_diagnostico_medico: "",
      ids_documentos_referencias_bibliograficas: [],
      referencia_bibliografica: ""
    },
    defaultDiagnosticoMedico: {
      cie10: "",
      codigo: "",
      diagnostico: "",
      documentos_referencias_bibliograficas: [],
      id_diagnostico_medico: "",
      ids_documentos_referencias_bibliograficas: [],
      referencia_bibliografica: ""
    },
    diagnosticosMedicosFocus: true,
    diagnosticoMedicos: [],
    url: null,
    controls: [
      'print',
      'rotate',
      'zoom',
      'catalog',
      'switchPage',
    ],

    defaultTratamiento: {
      id_medicamento: null,
      cantidad: 1,
      indicaciones: null
    },
    headersMedicamentos:[
      {
        text: "Tratamiento",
        value: "tratamiento",
        align: "center",
        sortable: false
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%",
        sortable: false
      }
    ],
    medicamentos: [],
    mostrar: true,
  }),
  mounted(){
    this.getEscalaCancerMamas();
    this.getDiagnosticosMedicos();
    this.getMedicamentos();
  },
  methods: {
    nombreEscala: escala => `[${escala.categoria}] - ${escala.descripcion}`,
    validate(){
      var valido = true;

      for (let i = 0; i < this.validations.length; i++) {
        if(typeof this.validations[i].especial != 'undefined' && this.validations[i].especial && this.validations[i].especial > 0){
          if(this.validations[i].especial == 1){
            if(this.editedItem.ant_pnp_implantes == true && !(this.editedItem.ant_pnp_implantes_derecha == true || this.editedItem.ant_pnp_implantes_izquierda == true)){
              valido = false;
              this.$refs.alert.setMessage("", `Debe de indicar si el Implante fue del lado Derecho o Izquierdo`);
              this.$refs.alert.open();
              break;
            }
          }

          else if(this.validations[i].especial == 2){
            if(this.editedItem.ant_pnp_implantes == true && (typeof this.editedItem.ant_pnp_implantes_fecha != 'string' ||  this.editedItem.ant_pnp_implantes_fecha.length <= 0)){
              valido = false;
              this.$refs.alert.setMessage("", `Debe de indicar la fecha en que se realizo el Implante`);
              this.$refs.alert.open();
              break;
            }
          }

          else if(this.validations[i].especial == 3){
            if(this.editedItem.ant_gin_mastectomia == true && !(this.editedItem.ant_gin_mastectomia_derecha == true || this.editedItem.ant_gin_mastectomia_izquierda == true)){
              valido = false;
              this.$refs.alert.setMessage("", `Debe de indicar si la Mastectomía fue del lado Derecho o Izquierdo`);
              this.$refs.alert.open();
              break;
            }
          }

          else if(this.validations[i].especial == 4){
            if(this.editedItem.ant_gin_mastectomia == true && (typeof this.editedItem.ant_gin_mastectomia_fecha != 'string' ||  this.editedItem.ant_gin_mastectomia_fecha.length <= 0)){
              valido = false;
              this.$refs.alert.setMessage("", `Debe de indicar la fecha en que se realizo la Mastectomia`);
              this.$refs.alert.open();
              break;
            }
          }

          else if(this.validations[i].especial == 5){
            if(this.editedItem.ant_gin_mastografia == true && (typeof this.editedItem.ant_gin_mastografia_fecha != 'string' ||  this.editedItem.ant_gin_mastografia_fecha.length <= 0)){
              valido = false;
              this.$refs.alert.setMessage("", `Debe de indicar la fecha en que se realizo la Mastografia`);
              this.$refs.alert.open();
              break;
            }
          }

          else if(this.validations[i].especial == 6){
            if(this.editedItem.ant_gin_mastografia == true && (typeof this.editedItem.ant_gin_mastografia_resultado != 'string' ||  this.editedItem.ant_gin_mastografia_resultado.length <= 0)){
              valido = false;
              this.$refs.alert.setMessage("", `Debe de indicar el resultado obtenido en la Ultima Mastografia`);
              this.$refs.alert.open();
              break;
            }
          }

          else if(this.validations[i].especial == 7){
            if(this.editedItem.ids_diagnosticos_medicos == null || this.editedItem.ids_diagnosticos_medicos.length <= 0 ){
              valido = false;
              this.$refs.alert.setMessage("", `Debe de indicar al menos un Diagnóstico`);
              this.$refs.alert.open();
              break;
            }
          }
        }

        else if(this.editedItem[this.validations[i].campo] == null || (this.validations[i].tipo == 'string' && this.editedItem[this.validations[i].campo].length < 0) || (this.validations[i].tipo == 'integer' && this.editedItem[this.validations[i].campo] <= 0)){
          valido = false;
          this.$refs.alert.setMessage("", `El Campo ${this.validations[i].nombre} es Obligatorio`);
          this.$refs.alert.open();
          break;
        }

        else if((this.validations[i].tipo == 'boolean' || this.validations[i].tipo == 'integer') && this.validations[i].otro == true && this.editedItem[this.validations[i].campo] == this.validations[i].valor_otro && ( this.editedItem[this.validations[i].campo+'_otros'] == null ||  this.editedItem[this.validations[i].campo+'_otros'].length < 0    )){
          valido = false;
          this.$refs.alert.setMessage("", `La Nota del Campo ${this.validations[i].nombre} es Obligatoria`);
          this.$refs.alert.open();
          break;
        }
      }
      return valido;
    },
    getData(){
      if(this.validate()) return Object.assign({}, this.editedItem);
      else return null;
    },
    setPaciente(paciente_info){
      try {
        if(!paciente_info || !paciente_info.signos_vitales) return;

        const sI = paciente_info.signos_vitales.sistolica_izquierda;
        const dI = paciente_info.signos_vitales.diastolostica_izquierda;
        const sD = paciente_info.signos_vitales.sistolica_derecha;
        const dD = paciente_info.signos_vitales.diastolostica_derecha;

        let ta = '';
        
        if (!this.stringIsNullOrEmpty(sI) || !this.stringIsNullOrEmpty(dI)) {
          ta += `${this.stringIsNullOrEmpty(sI) ? '?' : sI}/${this.stringIsNullOrEmpty(dI) ? '?' : dI} IZQ`;
        }

        if (!this.stringIsNullOrEmpty(sD) || !this.stringIsNullOrEmpty(dD)) {
          if(ta.length > 0) ta += ' - ';
          ta += `${this.stringIsNullOrEmpty(sD) ? '?' : sD}/${this.stringIsNullOrEmpty(dD) ? '?' : dD} DER`;
        }

        if(!this.stringIsNullOrEmpty(ta)) this.editedItem.ta = ta;

        this.editedItem.peso = paciente_info.signos_vitales.peso;
        this.editedItem.talla = paciente_info.signos_vitales.estatura;
        this.editedItem.circunferencia_abdominal = paciente_info.signos_vitales.cintura;
        this.editedItem.pulso = paciente_info.signos_vitales.pulso;
        this.editedItem.temp = paciente_info.signos_vitales.temperatura;
        this.editedItem.fr = paciente_info.signos_vitales.respiracion;
        this.editedItem.imc = paciente_info.signos_vitales.imc;

        //this.editedItem.gro = paciente_info.signos_vitales.?;
        //this.editedItem.rh = paciente_info.signos_vitales.?;
        this.editedItem.glucosa = paciente_info.signos_vitales.glucosa;
        this.editedItem.colesterol = paciente_info.signos_vitales.colesterol || paciente_info.signos_vitales.colesterol_otro;
        this.editedItem.trigliceridos = paciente_info.signos_vitales.trigliceridos || paciente_info.signos_vitales.trigliceridos_otro;
        //this.editedItem.acido_urico = paciente_info.signos_vitales.?;
        //this.editedItem.vdrl = paciente_info.signos_vitales.?;
        //this.editedItem.otros = paciente_info.signos_vitales.?;
      } catch (error) {
        console.log(error);
      }
    },
    calcularGestas(){
      this.editedItem.ant_gin_gestas = (
        this.editedItem.ant_gin_paras +
        this.editedItem.ant_gin_cesarias +
        this.editedItem.ant_gin_abortos
      )
    },
    getEscalaCancerMamas(){
      this.loadingEscalaCancerMamas = true;
      axios
      .get('/Catalogos/ListarEscalaCancerMamas')
      .then(response => {
        this.escalaCancerMama = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingEscalaCancerMamas = false;
      })
    },
    abrirDocumentosReferencia(item){
      if(item.ids_documentos_referencias_bibliograficas.length <= 0) return;

      this.diagnosticoMedico = Object.assign({}, item);
      this.diagnosticosMedicosFocus = false;
      this.$nextTick(() => {
        this.diagnosticosMedicosFocus = true;
        this.dialogDocumentReference = true;
      });
      

    },
    cerrarDocumentosReferencia(){
      this.diagnosticoMedico = Object.assign({}, this.defaultConsultaMedica);
      this.dialogDocumentReference = false;
      this.url = null;
    },
    borrarChip(item) {
      const index = this.editedItem.ids_diagnosticos_medicos.indexOf(item.id_diagnostico_medico);
      if (index !== -1) {
          this.editedItem.ids_diagnosticos_medicos.splice(index, 1);
      }
    },
    getDiagnosticosMedicos(){
      this.loadingDiagnosticosMedicos = true;
      axios
        .get('/Catalogos/ListarDiagnosticosMedicos')
        .then(response => {
          this.diagnosticoMedicos = response.data;
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loadingDiagnosticosMedicos = false;
        })
    },
    agregarMedicamento(){
      this.editedItem.tratamientos.push(Object.assign({}, this.defaultTratamiento))
    },
    eliminarMedicamento(item){
      this.editedItem.tratamientos = this.editedItem.tratamientos.filter(x => x != item);
    },
    medicamentoNombre: medicamento => `[${medicamento.codigo}] - ${medicamento.farmaco} ${medicamento.concentracion} - ${medicamento.stock} PZA - ${medicamento.presentacion}`,
    getMedicamentos(){
      this.loadingMedicamentos = true;
      axios
        .get('/Catalogos/ListarMedicamentos?mostrar_stock=true&mostrar_solo_mastografia=true')
        .then(response => {
          this.medicamentos = response.data;
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loadingMedicamentos = false;
        })
    },
    setUSG(estado){
      if(estado) this.editedItem.aux_diag_us = "Ultrasonido de Mama Bilateral";
      else this.editedItem.aux_diag_us = null;
    },
    clear(){
      this.editedItem.localizaciones = [];
      this.$refs.diagrama.clear();
      this.mostrar = false;
      setTimeout(() => {
        this.mostrar = true;
      }, 200);
      this.editedItem = Object.assign({}, this.defaultEditedItem);
    },
    resetImplantes(){
      this.editedItem.ant_pnp_implantes_derecha = null;
      this.editedItem.ant_pnp_implantes_izquierda = null;
      this.editedItem.ant_pnp_implantes_fecha = null;
    },
    resetMastografia(){
      this.editedItem.ant_gin_mastografia_fecha = null;
      this.editedItem.ant_gin_mastografia_resultado = null;
      this.editedItem.ant_gin_mastografia_tratamiento = null;
    },
    resetRealizarMastografia(){
      this.editedItem.ant_gin_mastectomia_derecha = null;
      this.editedItem.ant_gin_mastectomia_izquierda = null;
      this.editedItem.ant_gin_mastectomia_fecha = null;
    },
    stringIsNullOrEmpty(str) {
      return str === undefined || str === null || str === '';
    }
  }
}
</script>
